module.exports = __webpack_public_path__ + "img/img-1852cb.png";